// extracted by mini-css-extract-plugin
module.exports = {"divider":"FilterMenu__divider--31prx","active":"FilterMenu__active--vPcql"};